import { Stack, Typography } from "@mui/material"
import { FC } from "react"

import { useAccount } from "../../../../states/account"
import { useBooking } from "../../../../states/bookingDetail"
import { useBookings } from "../../../../states/bookings"
import { create } from "src/helpers/bem"

import { formatLocaleDate } from "src/helpers/date"
import { formatPrice } from "src/helpers/price"
import { useTranslation } from "src/hooks/translation"
import { useLocale } from "src/states/locale"

import { xRMWebshopOrderedItem } from "src/types/xRM"

import styles from "./OrderRow.module.scss"
const bem = create(styles, "OrderRow")

export type OrderRowProps = {
  item: xRMWebshopOrderedItem
  ordererName: string
  activeDebitorId: string
}

export const OrderRow: FC<OrderRowProps> = ({
  item,
  ordererName,
  activeDebitorId,
}) => {
  const locale = useLocale()
  const { booking } = useBooking()
  const { bookings } = useBookings()
  const { messages: translations } = useTranslation()
  const {
    contact: { debitorId, id: contactId } = {},
    firstName,
    lastName,
  } = useAccount()
  const statusTranslations = translations.pages.orderedServices.status

  const activeBooking = bookings.find(
    (actBooking) => actBooking.id === booking?.id,
  )
  const statusLabel =
    item.stornoStatus === "Active"
      ? statusTranslations.edited
      : item.stornoStatus === "Closed"
        ? statusTranslations.cancelled
        : statusTranslations.cancelRequest
  const currentUserName =
    firstName && lastName ? `${firstName} ${lastName}` : ""
  const showPrices =
    debitorId === activeDebitorId ||
    contactId === activeBooking?.senderContactId ||
    contactId === activeBooking?.contactId ||
    currentUserName === ordererName
  const customerInformation =
    (
      item as {
        customerInformation?: string | null
        customerinformation?: string | null
      }
    ).customerInformation ??
    (
      item as {
        customerInformation?: string | null
        customerinformation?: string | null
      }
    ).customerinformation

  return (
    <Stack className={bem()} direction={"column"} width="100%">
      <Stack direction={"row"}>
        <Stack direction={"column"} width={"40%"}>
          <Typography className={bem("title")} variant="h6">
            {item.name}
          </Typography>
          <Typography className={bem("subtitle")}>
            <span
              className={bem("subtitle__orderer")}
            >{`${translations.pages.orderedServices.items.orderer}: `}</span>
            {ordererName}
          </Typography>
          {customerInformation && (
            <Typography className={bem("customerInfo")}>
              <span
                className={bem("customerInfo__label")}
              >{`${translations.pages.orderedServices.items.customerInformation}: `}</span>
              <span className={bem("customerInfo__value")}>
                {customerInformation}
              </span>
            </Typography>
          )}
        </Stack>
        <Stack direction={"row"} justifyContent={"space-between"} width={"60%"}>
          <Stack direction={"row"} spacing={2}>
            <div className={bem("chip")}>
              <Typography>
                {formatLocaleDate(locale, item.orderDate, "dd.MM.yyyy")}
              </Typography>
            </div>
            {/*           {item.stornoStatus && (
              <div
                className={bem(
                  "chip",
                  item.stornoStatus === "Active" ? "success" : "error",
                )}
              >
                <Typography>{statusLabel}</Typography>
              </div>
            )} */}
          </Stack>
          <Stack direction={"row"} spacing={3}>
            <Stack direction={"column"}>
              <div className={bem("chip")}>
                <Typography>
                  {item.quantity} {item.unit}
                </Typography>
              </div>
            </Stack>
            {showPrices && (
              <Stack alignItems={"flex-end"} direction={"column"}>
                <Typography className={bem("totalPrice")}>
                  {formatPrice(
                    (item.unitPrice ?? 0) * (item.quantity ?? 0),
                    locale,
                  )}
                </Typography>
                <Typography className={bem("unitPrice")}>
                  {formatPrice(item.unitPrice, locale)}/ {item.unit}
                </Typography>
              </Stack>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
